<template>
  <v-dialog :value="isActiveCodes" max-width="1000" persistent>
    <v-card class="text-center quick-view">
      <v-card-title class="align-center font-weight-bold px-5">
        Thông tin mã sử dụng
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-simple-table class="table-layout pa-4 pt-0">
          <template v-slot:default>
            <thead>
            <tr>
              <th>Tên mã</th>
              <th>Loại mã</th>
              <th>SL môn</th>
              <th>Trạng thái</th>
              <th>Ngày gia hạn</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in activeCodesCustomer">
              <td>{{ item.activeCode }}</td>
              <td>{{ item.typeOfCode.name }}</td>
              <td>{{ item.numberOfSubject }}</td>
              <td>{{ getStatusActiveCode(item.status) }}</td>
              <td>{{ item.expiredTime }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
/deep/ .icon-child-name {
  position: inherit !important;
  padding-right: 10px;
  top: unset !important;
  right: unset !important;
}
.quick-view table thead tr th {
  font-size: 16px !important;
}

.quick-view table tr td {
  font-size: 13px !important;
}
</style>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
import * as moment from "moment";
import AgencyRepository from "../../../repositories/AgencyRepository";

export default {
  props: {
    isActiveCodes: {
      default: () => ({})
    },
    // activeCodesCustomer: {
    //   type: Array,
    //   default: () => []
    // },
    dataContact: {
      default: () => ({})
    }
  },
  data() {
    return {
      errorMessage: '',
      startTime: '',
      endTime: '',
      activeCodesCustomer: [],
      statusActiveCodeList: [
        {
          name: 'Đã kích hoạt',
          code: 'active'
        },
        {
          name: 'Chưa kích hoạt',
          code: 'pending'
        },
        {
          name: 'Ngừng hoạt động',
          code: 'inactive'
        }
      ]
    };
  },
  created() {
    this.viewActiveCodes()
  },
  methods: {
    closeModal() {
      Bus.$emit('close-active-code-modal')
    },
    async getStudyResult() {
      let params = {
        startTime: this.startTime,
        endTime: this.endTime
      }
      if(_.hasIn(this.dataStudyResult, 'study_result_multiple')) {
        params.fullName = this.dataStudyResultLocaly.user_name ? this.dataStudyResultLocaly.user_name : this.dataStudyResultLocaly.fullName;
      } else {
        params.fullName = this.dataStudyResult.fullName;
      }
      if (this.dataStudyResult.vhUserId) {
        params.user_id = this.dataStudyResult.vhUserId
      }
      if(this.dataStudyResultLocaly.user_id) {
        params.user_id = this.dataStudyResultLocaly.user_id
      }
      // if(this.tabIndex !== 3) {
      //   params.startTime = this.startTime
      //   params.endTime = this.endTime
      // }
      let res = await ContactRepository.getResultStudy(this.dataStudyResult.contactId, params);
      if(res.success && _.isArray(res.data)) {
        this.listDataComplexStudyResult = _.get(res, 'data', []);
        this.dataStudyResultLocaly = this.listDataComplexStudyResult[this.tabTitleIndex]
      } else if(res.success) {
        this.dataStudyResultLocaly = _.get(res, 'data', {});
      }
    },
    async viewActiveCodes() {
      this.appLoadingData(true);
      let params = {
        contactId: this.dataContact.id
      }
      const res = await AgencyRepository.listActiveCode(params);
      this.appLoadingData(false);
      if (res.success) {
        this.activeCodesCustomer = _.get(res, 'data', [])
      }
    },
    getStatusActiveCode(statusCode) {
      let indexStatus = this.statusActiveCodeList.findIndex(item => item.code == statusCode);
      if (indexStatus > -1) {
        return this.statusActiveCodeList[indexStatus].name
      }
      return '';
    }
  }
};
</script>